import * as React from "react";
import { styled } from "@mui/material";
import useSessionStore from "../context/useSessionStore";
import { MemoizedQuestion } from "./Question";
import { MemoizedAnswer } from "./Answer";
import { MessageSeparator } from "@chatscope/chat-ui-kit-react";
import { useTranslateByGender } from "fe-common/locale/useTranslateByGender";
import { MessageType, QuestionTypes } from "../types/types";
//region [[ Styles ]]

const ChatHistoryView = styled("div")({
  opacity: 0.8,
});

//endregion [[ Styles ]]

//region [[ Props ]]
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ChatHistory = () => {
  const { chatHistory, ragSettings, loadGuideline } = useSessionStore();
  const { translate } = useTranslateByGender();
  if (!chatHistory?.length) return null;
  return (
    <ChatHistoryView className={"chat-history-messages"}>
      {chatHistory?.map((msg, idx) =>
        msg.type === MessageType.question ? (
          <MemoizedQuestion msg={msg} key={"historicQuestion" + idx} historic />
        ) : (
          <MemoizedAnswer
            message={msg}
            debugMode={ragSettings.debugMode}
            questionType={QuestionTypes.Chat}
            key={"historicAnswer" + idx}
            historic
            question={chatHistory[idx - 1]?.text}
            getGuideline={loadGuideline}
          />
        ),
      )}
      <MessageSeparator content={translate("DIALOGUE_UPDATES_SUMMARY")} />
    </ChatHistoryView>
  );
};
